import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusThinkActive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.02606 1.40396C5.30953 0.75 6.98969 0.75 10.35 0.75H12.65C16.0103 0.75 17.6905 0.75 18.9739 1.40396C20.1029 1.9792 21.0208 2.89709 21.596 4.02606C22.25 5.30953 22.25 6.98969 22.25 10.35V12.65C22.25 16.0103 22.25 17.6905 21.596 18.9739C21.0208 20.1029 20.1029 21.0208 18.9739 21.596C17.6905 22.25 16.0103 22.25 12.65 22.25H10.35C6.98969 22.25 5.30953 22.25 4.02606 21.596C2.89708 21.0208 1.9792 20.1029 1.40396 18.9739C0.75 17.6905 0.75 16.0103 0.75 12.65V10.35C0.75 6.98969 0.75 5.30953 1.40396 4.02606C1.9792 2.89708 2.89709 1.9792 4.02606 1.40396ZM12.25 7.5C12.25 7.08579 11.9142 6.75 11.5 6.75C11.0858 6.75 10.75 7.08579 10.75 7.5V10.75H7.5C7.08579 10.75 6.75 11.0858 6.75 11.5C6.75 11.9142 7.08579 12.25 7.5 12.25H10.75V15.5C10.75 15.9142 11.0858 16.25 11.5 16.25C11.9142 16.25 12.25 15.9142 12.25 15.5V12.25H15.5C15.9142 12.25 16.25 11.9142 16.25 11.5C16.25 11.0858 15.9142 10.75 15.5 10.75H12.25V7.5Z",
		fill: "currentColor"
	})
});
export default SvgPlusThinkActive;
